export enum Unreconciledreportperiod {
    ThisMonth = 'This Month',
    LastMonth = 'Last Month',
    ThisQuarter = 'This Quarter',  
    LastQuarter = 'Last Quarter',  
    ThisFinancialYear = 'This Financial Year',  
    LastFinancialYear = 'Last Financial Year',
    CustomRange = 'Custom Range'
  }
  